<ng-template [vbCssRules]="themeStyleOverrides">
</ng-template>
<!--
	TODO: typeahead-editable not yet implemented
	https://github.com/valor-software/ngx-bootstrap/blob/development/src/typeahead/typeahead.directive.ts#L158
	typeahead-editable="!!typeaheadCfg.getEnteredValueWhenNoSuggestion"
 -->
<form layout="row" layout-wrap="false" name="form" #typeaheadForm="ngForm">
	<div class="btn-group" [ngClass]="styles.inputWrap" role="search">

		<input type="text" autocomplete="off" name="editValue" role="combobox" vbUiTextInput [ngClass]="inputClass" [attr.aria-label]="typeaheadCfg.label" [placeholder]="typeaheadCfg.label" [(ngModel)]="internalValue" [required]="required" #typeahead="bs-typeahead" [typeahead]="typeaheadObservable$" [typeaheadMinLength]="typeaheadMinLength" [attr.maxLength]="typeaheadMaxLength" [typeaheadWaitMs]="TypeaheadDelayMs" [typeaheadIsFirstItemActive]="false" [typeaheadSelectFirstItem]="false" [optionsListTemplate]="customListTemplate" [typeaheadOptionField]="typeaheadCfg.searchField" (typeaheadLoading)="onTypeaheadLoading($event)" (typeaheadNoResults)="onTypeaheadNoResults($event)" (typeaheadOnSelect)="onSelect($event)" (blur)="onInputBlur()" vbKeypress [isKeyUp]="true" (enterKeyPressed)="onEnterKeyPressed()">
		<button *ngIf="isSearchType" class="flex-center-align main-nav-btn" [attr.aria-label]="'Navigation_SearchMedia' | translate " [ngClass]="[styles.noLeftBorderRadius, typeaheadCfg.btnCfg.cssClass]" type="button" (click)="onTypeaheadSubmit()">
			<span class="vb-icon vb-icon-search"></span>
			<span class="mobile-hidden" [hidden]="!typeaheadCfg.btnCfg.label">{{typeaheadCfg.btnCfg.label}}</span>
		</button>
		<div class="theme-header" [ngClass]="[
				styles.dropdownMenu,
				typeaheadCfg.source === 'HeaderSearch' && typeaheadCfg.headerType === 'TwoTier' ? styles.twoTierDropdownMenu : '',
			]" [hidden]="!(typeaheadLoading || typeaheadNoResults)">
			<vb-loading-spinner [block]="true" [size]="'large'" [ngClass]="styles.fadeInOut" [hidden]="!(typeaheadLoading)">
			</vb-loading-spinner>
			<span [ngClass]="styles.fadeInOut" [hidden]="!(typeaheadNoResults) || typeaheadCfg.hideNoResult">
				{{ 'UI_NoResultsFound' | translate }}
			</span>
		</div>
	</div>
	<button *ngIf="isOkCancelType" class="margin-left-5" [title]="'Apply' | translate " type="button" (click)="onTypeaheadSubmit()" [disabled]="typeaheadForm.invalid" vbBtnPrimary>
		<span class="glyphicons ok_2"></span>
	</button>
	<button *ngIf="isOkCancelType" class="margin-left-5" [title]="'Discard' | translate " type="button" (click)="endEdit()" vbBtnSecondary>
		<span class="glyphicons remove_2"></span>
	</button>
</form>

<ng-template #customListTemplate let-matches="matches" let-query="query" let-typeaheadTemplateMethods>
	<ul class="custom-list-group theme-header">
		<li class="custom-list-group-item typeahead-list-item" [ngClass]="typeaheadTemplateMethods.isActive(match) ? 'typeahead-match-active' : ''" *ngFor="let match of matches" (mouseenter)="typeaheadTemplateMethods.selectActive(match)">
			<a href="#" class="theme-header" (click)="typeaheadTemplateMethods.selectMatch(match, $event)" tabindex="-1" [attr.title]="match">
				<span [innerHTML]="this.typeahead._container?.highlight(match, query)"></span>
			</a>
		</li>
	</ul>
</ng-template>
